// @core/api/endpoints/billing/create_invoice_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateInvoiceNumberingSchemeRequest,
  InvoiceNumberingSchemeResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create invoice numbering scheme
 * Creates an invoice numbering scheme defining how invoice numbers are generated (e.g., INV-2026-001).
 */
export async function CreateInvoiceNumberingScheme(
  data: CreateInvoiceNumberingSchemeRequest,
  options?: RequestOptions
): Promise<InvoiceNumberingSchemeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invoice-numbering-schemes`;
  const requestOptions = options;
  return client.post<InvoiceNumberingSchemeResponse>(requestPath, data, requestOptions);
}
